import { useEffect, useState } from "react";
import { Api } from "../../lib/api";

/**
 * Simple one-form RSVP booking state.
 * Pricing is intentionally hidden — we just hold a "Book your place" reservation
 * (event + qty + contact) and create a `payment_method: "rsvp"` booking that
 * emails a holding confirmation with a QR.
 */
export default function useBookingForm() {
  const [events, setEvents] = useState([]);
  const [tickets, setTickets] = useState([]);

  const [eventId, setEventId] = useState(null);
  const [qty, setQty] = useState(1);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    Api.events().then(setEvents).catch(() => {});
    Api.tickets().then(setTickets).catch(() => {});
  }, []);

  const event = events.find((e) => e.id === eventId);
  const canSubmit =
    !!eventId && qty > 0 && name.trim() && email.includes("@") && tickets.length > 0;

  async function submit() {
    if (!canSubmit) return;
    setLoading(true);
    setError(null);
    try {
      const booking = await Api.createBooking({
        event_id: eventId,
        ticket_id: tickets[0].id, // RSVP — first tier as placeholder
        quantity: qty,
        addon_ids: [],
        customer_name: name,
        customer_email: email,
        payment_method: "rsvp",
      });
      const params = new URLSearchParams({
        rsvp: "1",
        booking: booking.id,
        share: booking.share_code || "",
      });
      window.location.href = `/booking-success?${params.toString()}`;
    } catch (e) {
      setError(e.response?.data?.detail || e.message || "Could not reserve");
      setLoading(false);
    }
  }

  return {
    events,
    eventId,
    setEventId,
    qty,
    setQty,
    name,
    setName,
    email,
    setEmail,
    event,
    canSubmit,
    loading,
    error,
    submit,
  };
}
